import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export function useImportFile() {
  const [loading, setLoading] = useState(false);

  async function execute(formData: FormData, callback?: () => void) {
    try {
      setLoading(true);
      const response = await api.post('v1/backoffice/import-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (callback) callback();

      return response.data;
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
